export default import.meta.ROLLDOWN_FILE_URL_cEBmov2sfhKlkyg9TXv21Q